<template>
  <div class="px-2">
    <div
      class="widget-12 card card-default widget-loader-circle shade"
    >
      <div class="card-body">
        <div class="row">
          <div class="col-md-5 col-sm-12" data-v-step="9">
            <div class="row">
              <div class="col-md-8 col-sm-">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Sentimen</h4>
                  <p class="small hint-text">
                    Menampilkan komparasi sentimen per topik
                  </p>
                </div>
              </div>
              <div class="col-md-4" align="right">
                <div class="form-check form-check-inline switch m-t-20">
                  <input
                    type="checkbox"
                    id="pagesSwitch"
                    v-on:click="tableToggle"
                  />
                  <label for="pagesSwitch">Tampilkan Tabel</label>
                </div>
              </div>
            </div>
            <div class="row" style="min-height: 300px !important">
              <div class="col-md-12 col-sm-12">
                <loader-component v-if="isLoading" />
                <table-dynamic-component
                  :data_head="data_head"
                  :data_body="data_body"
                  :config="dt_config"
                  :table_class="dt_class"
                  class="fade-in"
                  v-if="isTabel === 'yes' && !isLoading"
                />
                <bar-chart-component
                  :key="bar_chart_key"
                  v-if="isTabel === 'no' && !isLoading"
                  :topik="data_topik"
                  :series="data_bar_chart"
                />
              </div>
            </div>
          </div>
          <div class="col-md-7 col-sm-12" data-v-step="10">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Posting</h4>
                  <p class="small hint-text">
                    Menampilkan Posting Terbaru dan Terpopuler
                  </p>
                </div>
              </div>
            </div>
            <div class="card card-borderless">
              <ul
                class="nav nav-tabs nav-tabs-simple"
                role="tablist"
                data-init-reponsive-tabs="dropdownfx"
              >
                <li class="nav-item">
                  <a
                    class="active"
                    href="#"
                    data-toggle="tab"
                    role="tab"
                    data-target="#tab2FollowUs"
                  >
                    <i class="bi bi-star-fill text-blue"></i> Terbaru
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    data-toggle="tab"
                    role="tab"
                    data-target="#tab2hellowWorld"
                    href="#"
                  >
                    <i class="bi bi-chat-fill text-blue"></i> Terpopuler
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab2FollowUs">
                  <loader-component v-if="isLoading" />
                  <alert-dynamic-component
                    v-else-if="isError"
                    type="danger"
                    :title="notif_title"
                    :subtitle="notif_message"
                  />
                  <carousel-post-component v-else :data="data_sosmed[0]" />
                </div>
                <div class="tab-pane" id="tab2hellowWorld">
                  <loader-component v-if="isLoading" />
                  <alert-dynamic-component
                    v-else-if="isError2"
                    type="danger"
                    :title="notif_title"
                    :subtitle="notif_message"
                  />
                  <carousel-post-component v-else :data="data_sosmed[1]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bar_chart from "@/views/components/chart/bar_chart.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import loader_component from "@/views/components/loader.vue";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import carousel_post_list from "./carousel_post_list.vue";

var data_table_config = {
  lengthChange: false,
  pageLength: 5,
  columnDefs: [{ width: "20%", targets: 0 }],
};
var table_class = "table-bordered";
var table_header = [
  "Topik",
  "Sentimen Positif",
  "Sentimen Netral",
  "Sentimen Negatif",
];

export default {
  name: "medsos_sentiment_post",
  components: {
    "bar-chart-component": bar_chart,
    "table-dynamic-component": table_dynamic,
    "loader-component": loader_component,
    "alert-dynamic-component": alert_dynamic,
    "carousel-post-component": carousel_post_list,
  },
  props: {
    data_grafik: Object,
  },
  data() {
    return {
      isTabel: "no",
      data_head: table_header,
      data_body: null,
      dt_config: data_table_config,
      dt_class: table_class,

      data_bar_chart: null,
      data_topik: null,
      post_terbaru: null,
      post_terpopuler: null,

      isLoading: true,
      isError: false,
      isError2: false,

      bar_chart_key: 0,
      post_terbaru_key: 0,
      post_terpopuler_key: 0,

      notif_title: "",
      notif_message: "",

      id_project: this.$store.getters.user.id_project,

      data_sosmed: [
        [
          {
            id: "terbaru-sosmed",
            is_socmed: true,
            sort: "date",
          },
        ],
        [
          {
            id: "popular-sosmed",
            is_socmed: true,
            sort: "esmr",
          },
        ],
      ],
    };
  },
  methods: {
    tableToggle: function () {
      if (this.isTabel == "no") {
        this.isTabel = "yes";
      } else {
        this.isTabel = "no";
      }
    },
    assembleDataGrafik: function () {
      if (this.data_grafik != null) {
        let selected_topic_key = null;
        if ("topic" in this.$route.query) {
          this.data_topik = [];
          for (let key in this.data_grafik.topics) {
            if (this.data_grafik.topics[key].id == this.$route.query.topic) {
              this.data_topik.push(this.data_grafik.topics[key]);
              selected_topic_key = key;
            }
          }
        } else {
          this.data_topik = this.data_grafik.topics;
        }

        let data_tabel = [];
        let data_bar_chart = [];
        let chart_values = {};
        let key_value = [];
        let obj_key_value = {};
        let key_grafik = ["positif", "negatif", "netral"];
        for (let obj_key in this.data_grafik) {
          if (obj_key == "topics") {
            for (let arr_key in this.data_grafik[obj_key]) {
              if (typeof data_tabel[arr_key] == "undefined") {
                data_tabel[arr_key] = [];
              }
              data_tabel[arr_key][0] = this.data_grafik[obj_key][arr_key].nama;
            }
          }
          if (key_grafik.includes(obj_key)) {
            key_value = [];
            for (let arr_key in this.data_grafik[obj_key]) {
              if (obj_key == "positif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][1] = this.data_grafik[obj_key][arr_key];
              }
              if (obj_key == "netral") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][2] = this.data_grafik[obj_key][arr_key];
              }
              if (obj_key == "negatif") {
                if (typeof data_tabel[arr_key] == "undefined") {
                  data_tabel[arr_key] = [];
                }
                data_tabel[arr_key][3] = this.data_grafik[obj_key][arr_key];
              }
              obj_key_value = {
                x: parseInt(arr_key),
                y: this.data_grafik[obj_key][arr_key],
              };
              if (selected_topic_key != null) {
                if (selected_topic_key == arr_key) {
                  key_value.push(obj_key_value);
                }
              } else {
                key_value.push(obj_key_value);
              }
            }
            chart_values = {
              key: this.capitalizeWords(obj_key),
              values: key_value,
            };
            if (obj_key == "positif") data_bar_chart[0] = chart_values;
            if (obj_key == "netral") data_bar_chart[1] = chart_values;
            if (obj_key == "negatif") data_bar_chart[2] = chart_values;
          }
        }

        this.data_body = data_tabel;
        this.data_bar_chart = data_bar_chart;
        this.isLoading = false;
        this.bar_chart_key++;
      }
    },
    getData: function (sort, var_to_assign) {
      var self = this;
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      query += "&sort=" + sort + "&items=5";
      let component_key_var = var_to_assign + "_key";
      if (this.query != query && query != "") {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "posts-dev/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then(function (response) {
            if (response.status == 204) {
              self[var_to_assign] = [];
            } else {
              self[var_to_assign] = response.data.posts;
            }

            self.isLoading = false;
            self.isError = false;
            self[component_key_var]++;
          })
          .catch(function (err) {
            self.resp = err.response;
            self.notif_title = "Error!<br/>";
            self.notif_message = err.response.data.status;
            if (sort == "date") {
              self.isError = true;
            } else {
              self.isError2 = true;
            }
          })
          .finally(function () {
            self.isLoading = false;
          });
      }
    },
    getPers: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "pers";
      this.$http.get(api).then(function (response) {
        self.getData("esmr", "post_terpopuler");
        self.getData("date", "post_terbaru");
        self.pers = response.data;
      });
    },
    capitalizeWords: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
  created: function () {
    this.assembleDataGrafik();
    if (this.data_grafik != null) {
      this.getPers();
    }
  },
};
</script>

<style scoped>
.nav-tabs-simple > li > a:after {
  background-color: #0f8ff9 !important;
}
</style>